module.exports = __webpack_public_path__ + "img/second_it.6227e479.jpg";